import Carousel from "react-multi-carousel";
import FrameworkTitle from "./components/FrameworkTitle/FrameworkTitle";
import PlaylistItem from "./components/PlaylistItem/PlaylistItem";
import "@detail/Pages/DetailPage/CarrouselStyle.css";
import "react-multi-carousel/lib/styles.css";
import style from "./style.module.css";
import { onlyOne, poster_v2, responsive_v2, responsive_directo_v2 } from "../../../../detail/src/Pages/DetailPage/CarrouselStyle";
import "./carousel.css";
import {
  TRANSITION_DURATION,
  WIDGET_TYPE_GRID,
  WIDGET_TYPE_GRID_GROUP,
  WIDGET_TYPE_POSTER,
  WIDGET_TYPE_LIVE_V2,
  WIDGET_TYPE_BANNER,
} from "../../Utils/Constants";
import MobileScrollCarousel from "@detail/Pages/DetailPage/Widgets/MobileScrollCarousel";
import useIsMobileViewport from "@detail/Pages/DetailPage/Widgets/useIsMobileViewport";

const DefaultWidgetComponent_V2 = ({
  id,
  backgroundColor,
  backgroundImage,
  titleColor,
  title,
  hasMoreContents,
  playlist,
  typeBanner,
  trigger,
  event,
  isSmall,
}) => {
  const isMobileViewport = useIsMobileViewport();
  const isMobile = isMobileViewport;

  const itemMaxWidth = (typeBanner === WIDGET_TYPE_BANNER || 
    typeBanner === WIDGET_TYPE_LIVE_V2) ? "320px" : (typeBanner === WIDGET_TYPE_POSTER) ? "160px" : "100px";

  const playlistBackgroundStyle = {
    backgroundColor,
    ...(backgroundImage?.url && {
      backgroundImage: `url(${backgroundImage.url})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }),
  };

  return (
    <>
      <div className={style.playlist} style={playlistBackgroundStyle}>
        <FrameworkTitle
          id={id ?? 0}
          hasMoreContents={hasMoreContents}
          titleColor={titleColor}
          title={title}
        />
        {!!playlist?.length &&
          (typeBanner === WIDGET_TYPE_GRID || typeBanner === WIDGET_TYPE_GRID_GROUP ? (
            <div className={style.gridWidget}>
              {playlist?.map((item) => (
                <PlaylistItem
                  key={item.id}
                  item={item}
                  trigger={trigger}
                  event={event}
                  typeBanner={typeBanner}
                />
              ))}
            </div>
          ) : (
            <>
              {isMobile ? (
                <MobileScrollCarousel
                  itemWidth="calc(50vw - 12px)"
                  itemMaxWidth={itemMaxWidth}
                  containerClassName={`carousel-container ${typeBanner}`}
                >
                  {playlist?.map((item) => (
                    <div key={item.id}>
                      <PlaylistItem
                        item={item}
                        trigger={trigger}
                        event={event}
                        typeBanner={typeBanner}
                        isSmall={isSmall}
                      />
                    </div>
                  ))}
                </MobileScrollCarousel>
              ) : (
                <div id="carousel_v2" className={isMobile ? "carouselButtonLeft" : ""}>
                  <Carousel
                    showDots={false}
                    arrows={true}
                    responsive={
                      playlist.length === 1
                        ? onlyOne
                        : typeBanner === WIDGET_TYPE_POSTER
                          ? poster_v2
                          : typeBanner === WIDGET_TYPE_LIVE_V2 || typeBanner === WIDGET_TYPE_BANNER
                            ? responsive_directo_v2
                            : responsive_v2
                    }
                    autoPlay={false}
                    transitionDuration={parseInt(TRANSITION_DURATION)}
                    customTransition={
                      isMobile
                        ? "transform 300ms ease-in-out 0s"
                        : "transform 500ms ease-in-out 0s"
                    }
                    containerClass={style.carousel}
                  >
                    {playlist?.map((item) => (
                      <PlaylistItem
                        key={item.id}
                        item={item}
                        trigger={trigger}
                        event={event}
                        typeBanner={typeBanner}
                        isSmall={isSmall}
                      />
                    ))}
                  </Carousel>
                </div>
              )}
            </>
          ))}
      </div>
    </>
  );
};

export default DefaultWidgetComponent_V2;
